import React from 'react';
import { UserGoal } from '../../api/services/UserGoalsService';
import { useTranslation } from '../../i18n/provider';
import styles from './DailyGoalSummaryCard.module.css';

type Props = {
  goal: UserGoal;
  showCalculator: boolean;
  onToggle: () => void;
  disabled?: boolean;
};

const DailyGoalSummaryCard: React.FC<Props> = ({ goal, showCalculator, onToggle, disabled = false }) => {
  const { t } = useTranslation();
  return (
    <div
      onClick={disabled ? undefined : onToggle}
      className={styles.card}
      style={disabled ? { opacity: 0.65, cursor: 'not-allowed' } : undefined}
    >
      <div className={styles.header}>
        <h3 className={styles.title}>{t('food.dailyGoal.title')}</h3>
        <div className={styles.footer}>{showCalculator ? t('food.dailyGoal.hide') : t('food.dailyGoal.edit')}</div>
      </div>
      <div className={styles.grid}>
        <div className={styles.item}>
          <div className={styles.label}>{t('food.dailyGoal.caloriesPerDay')}</div>
          <div className={styles.value}>{goal.dailyCalories}</div>
        </div>
        <div className={styles.item}>
          <div className={styles.label}>{t('food.dailyGoal.protein')}</div>
          <div className={styles.value}>{goal.dailyProtein}</div>
        </div>
        <div className={styles.item}>
          <div className={styles.label}>{t('food.dailyGoal.carbs')}</div>
          <div className={styles.value}>{goal.dailyCarbs}</div>
        </div>
        <div className={styles.item}>
          <div className={styles.label}>{t('food.dailyGoal.fats')}</div>
          <div className={styles.value}>{goal.dailyFats}</div>
        </div>
      </div>
    </div>
  );
};

export default DailyGoalSummaryCard;
